let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3J4FI")).then(() => parcelRequire('1nusn'));